<template>
    <div id="modal-assign-tag">

        <div class="rp-overlay h-full"></div>

        <div class="rp-modal" style="width: 470px;">

            <div class="rp-modal-header">
                <h3 class="rp-modal-title">{{ $t('Tag assignment') }}</h3>
                <button class="rp-btn-dismiss"
                    @click="$emit('closeModal')">
                    <XIcon class="w-5 h-5" />
                </button>
            </div>

            <div class="bg-white p-5">

                <div v-if="layout.loading" class="intro-y col-span-12 lg:col-span-12 flex flex-col justify-center items-center mt-5 mb-5">
                    <LoadingIcon icon="ball-triangle" class="w-12 h-12" />
                </div>

                <div v-else>
                    <div v-if="selectedImages && selectedImages.length" class="text-lg truncate mb-2">{{ $t('Selected items') }}: {{ selectedImages.length }}</div>
                    <div class="text-xs truncate mb-1">{{ $t('Select the tag you want to assign') }}:</div>

                    <div v-if="layout.dataset && layout.dataset.tags" class="pt-3 pb-5 text-left overflow-y-auto hidden-scrollbar" style="max-height: 500px;">
                        <div v-for="(tag, idx) in layout.dataset.tags" :key="idx">  
                            <button class="btn mb-1 hover:bg-blue-500 hover:text-white w-full text-left font-normal" 
                                @click="selectTag(tag, idx)"
                                :class="isTagSelected(tag, idx) ? 'rp-bg-blue-1 text-white' : 'text-gray-600'">
                                <div class="float-left w-12">
                                    <div class="h-8 w-8 rounded display-inline" 
                                        :style="tag.color ? 'background-color:' + tag.color + ';border: 2px solid #fff' : ''">
                                    </div> 
                                </div>
                                <div class="float-right w-80 ml-1 text-left text-sm">
                                    <span class="text-left">{{ tag.name }} 
                                        <span v-if="layout.dataset.tagStats && layout.dataset.tagStats.tags && layout.dataset.tagStats.tags[idx]" class="float-right">{{ layout.dataset.tagStats.tags[idx] }}</span>
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>

                    <div class="rp-modal-body-buttons gap-3 mt-4" style="justify-content: center;">
                        <button class="rp-btn-secondary" @click="emit('closeModal')">
                            {{ $t('Cancel') }}
                        </button>
                        <button class="rp-btn-primary" @click="setTag()" :disabled="!hasSelectedTag()">
                            {{ $t('Confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref }   from "vue";
import { helper as $h } 	from "@/utils/helper";
import * as rosepetalModel  from "rosepetal-model";

const $image    = rosepetalModel.default.image;
const $dataset  = rosepetalModel.default.dataset;

const emit = defineEmits(['closeModal', 'tagAssigned']);

const props = defineProps({
    dataset: {
        type: Object,
        required: true,
    },
    selectedImages: {
        type: Array,
        required: false,
        default: () => []
    },
    crop: {
        type: Object,
        required: false,
    },
    cropsMap: {
        type: Object,
        required: false,
    }
});

const layout = ref({
    loading:        false,
    dataset:        false,
    selectedCrop:   false,
    selectedTag:    false,
    selectedTagIdx: false
});

const selectTag = (tag, idx) => {
    if (props.crop) {
        layout.value.selectedTag = tag;
    } else {
        layout.value.selectedTagIdx = idx;
    }
}

const isTagSelected = (tag, idx) => {
    if (props.crop) {
        return layout.value.selectedTag && layout.value.selectedTag.id === tag.id;
    } else {
        return layout.value.selectedTagIdx === idx;
    }
}

const hasSelectedTag = () => {
    if (props.crop) {
        return layout.value.selectedTag !== false;
    } else {
        return layout.value.selectedTagIdx !== false;
    }
}

const setTag = async () => {
    if (props.crop && layout.value.selectedCrop !== false && layout.value.selectedTag !== false && layout.value.selectedTag.id !== layout.value.selectedCrop.id) {
        layout.value.selectedCrop.id = layout.value.selectedTag.id;
        layout.value.selectedCrop.modified = true;
        emit('closeModal');
        return;
    }

    if (props.selectedImages && props.selectedImages.length && layout.value.selectedTagIdx !== false) {
        layout.value.loading = true;
        
        await Promise.all(
            props.selectedImages.map(async imgId => {
                await $image.setTag(imgId, props.dataset.id, layout.value.selectedTagIdx);
            })
        );
        
        $h.NotificationTxt({ text: props.selectedImages.length + " media tag updated" });
        
        layout.value.selectedTagIdx = false;
        layout.value.loading = false;
        
        emit('tagAssigned');
        emit('closeModal');
    }
}

onMounted(() => {
    if (props.dataset) {
        layout.value.dataset = props.dataset;
    }

    if (props.cropsMap) {
        layout.value.cropsMap = props.cropsMap;
    }

    if (props.crop) {
        layout.value.selectedCrop   = props.crop;
        layout.value.selectedTag    = props.crop;
    }
});
</script>